export const TELESALES_API_URL = `${
  process.env.NEXT_PUBLIC_BASE_URL_PLATFORM ||
  "http://platform-api.asiatech.ptp"
}/telesales/requests`;

export const datalayerAppName = {
  international_hotel: "international_hotel",
  "hotel-international": "international_hotel",
  hotel: "domhotel",
  "hotel-domesitc": "domhotel",
  flight: "flight",
  international_flight: "int-flight",
  bus: "bus",
  train: "train",
  tour: "tour",
  villa: "villa",
  cip: "cip",
  visa: "visa"
};
